import { useContext } from 'react';
import classNames from "classnames";
import {observer} from "mobx-react";
import PropTypes from 'prop-types';

import { AuthenticationController } from "../../../../backends/YiiRoutes";
import styles from './styles/LoginButtons.module.scss';
import JSONWebToken from "../../../../utils/JSONWebToken";
import {StoreContext} from "../../../../stores/StoreLoader";
import {getConfig} from "../../../../_configs/AppConfig";

function ComponentToDisplay(props) {
    if (props.onClick) {
        return <button onClick={props.onClick} aria-label={props.item.label}>{props.children}</button>
    } else {
        return <a type={"button"} href={props.item.href} aria-label={props.item.label}>{props.children}</a>;
    }
}

const {publicRuntimeConfig} = getConfig();

const LoginButton = observer(props => {
    const {interfaceStore, i18nStore, organizationStore} = useContext(StoreContext);

    const jwt = new JSONWebToken().encode(organizationStore.organization.id,
                                          interfaceStore.currentFullUrl
    );

    const baseLoginUrl = interfaceStore.isSchoolBlocks ? "" : `https://login.${publicRuntimeConfig.APP_ENV}.schoolblocks.com`;

    const buttonData = {
        google: {
            label: "Sign in with Google",
            href: baseLoginUrl + AuthenticationController.google(i18nStore.currentOrgSupportedLocale, jwt),
        },
        office: {
            label: "Sign in with Office 365",
            href: baseLoginUrl + AuthenticationController.office365(i18nStore.currentOrgSupportedLocale, jwt),
        },
        facebook: {
            label: "Sign in with Facebook",
            href: baseLoginUrl + AuthenticationController.facebook(i18nStore.currentOrgSupportedLocale, jwt, props.fetchAccounts),
        },
    };

    const loginButtonClassName = classNames({
        [styles.loginButton]: true,
        [styles.loginButtonGoogle]: props.type === 'google',
        [styles.loginButtonOffice]: props.type === 'office',
        [styles.loginButtonFacebook]: props.type === 'facebook',
    });
    const loginButtonLogoContainerClassName = classNames({
        [styles.loginButtonLogoContainer]: true,
    });
    const loginButtonLogoClassName = classNames({
        [styles.loginButtonLogo]: true,
        [styles.loginButtonLogoGoogle]: props.type === 'google',
        [styles.loginButtonLogoOffice]: props.type === 'office',
        [styles.loginButtonLogoFacebook]: props.type === 'facebook',
    });
    const loginButtonTextClassName = classNames({
        [styles.loginButtonText]: true,
        [styles.loginButtonTextGoogle]: props.type === 'google',
        [styles.loginButtonTextOffice]: props.type === 'office',
        [styles.loginButtonTextFacebook]: props.type === 'facebook',
    });

    const item = buttonData[props.type];

    return (
        <ComponentToDisplay onClick={props.onClick} item={item}>
            <div className={loginButtonClassName}>
                <div className={loginButtonLogoContainerClassName}>
                    <div className={loginButtonLogoClassName} />
                </div>
                <div className={loginButtonTextClassName}>
                    {item.label}
                </div>
            </div>
        </ComponentToDisplay>
    )
})

LoginButton.propTypes = {
    type: PropTypes.oneOf(['google', 'office', 'facebook']).isRequired,
    onClick: PropTypes.func,
    fetchAccounts: PropTypes.bool, // flag only used for facebook
}

LoginButton.defaultProps = {
    fetchAccounts: false,
}

export default LoginButton;
